import React, { useState } from 'react';
import { Link } from 'react-scroll';

const ArrowLink = ({ to, onClick, label }) => {
  const [hovered, setHovered] = useState(false);

  const arrowStyle = {
    position: 'fixed',
    right: '20px',
    bottom: '20px',
    padding: '10px',
    borderRadius: '5px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    transition: 'all 0.2s ease-out',
  };
  const containerStyle = {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  };
  const labelStyle = {
    display: 'inline-block',
    whiteSpace: 'nowrap',
    transition: 'opacity 0.2s ease-out, transform 0.2s ease-out',
  };
  const arrowBeforeStyle = {
    content: '',
    display: 'block',
    width: 0,
    height: 0,
    borderLeft: '15px solid #000',
    borderRight: 'none',
    borderTop: '15px solid transparent',
    borderBottom: '15px solid transparent',
    transform: 'rotate(0deg)',
    marginLeft: '10px',
    animation: `${hovered ? 'arrowBlink' : ''} 1s linear infinite`,
  };
  
  const keyframes = `
    0% {
      transform: translateX(0);
    }
    50% {
      transform: translateX(10px);
      opacity: 1;
    }
    100% {
      transform: translateX(0);
      opacity: 0;
    }
  `;
  
  const animation = `
    @keyframes arrowBlink {
      ${keyframes}
    }
  `;
  
  return (
    <div style={{ width: '100%', position: 'fixed', bottom: '0' }}>
      <Link
        to={to}
        smooth={true}
        onClick={onClick}
        duration={500}
        style={arrowStyle}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <div style={containerStyle}>
          <span style={labelStyle}>{label}</span>
          <span style={arrowBeforeStyle}></span>
        </div>
      </Link>
      <style>{animation}</style>
    </div>
  );
  
};

export default ArrowLink;
